export default __webpack_public_path__ + "static/seth-f8cb692fe6ee9ae40cfed37d23dca3fa.jpg";